<template>
    <v-app>
        <mainMenu></mainMenu>
        <v-container>
            <v-card>
                <v-card-text>
                    <h1>Product Sales Report</h1>
                    <hr>
                    <v-layout>
                        <v-flex xs1 mr-2>
                            <v-select :items="itemYear" v-model="year" label="Year:" @change="changeMonth"></v-select>
                        </v-flex>
                        <v-flex xs2>
                            <v-select :items="itemMonth" v-model="month" label="Month:" item-text="name" item-value="id" @change="searchMonth"></v-select>
                        </v-flex>
                    </v-layout>
                    <v-data-table :headers="headerProd" :items="prodList" class="elevation-1">
                        <template v-slot:no-data>
                            <!-- <v-progress-linear v-slot:progress color="primary" indeterminate></v-progress-linear> -->
                            <v-alert class="text-center" color="info" icon="info" :value="true" outline>
                                No data found in this month
                            </v-alert>
                        </template>
                        <template v-slot:items="props">
                            <td>{{props.item.code}}</td>
                            <td>{{props.item.name}}</td>
                            <td class="text-xs-right">{{props.item.num}}</td>
                            <td class="text-xs-right">{{props.item.amt.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}</td>
                        </template>
                        <template v-slot:footer>
                            <td><strong>Total:</strong></td>
                            <td></td>
                            <td class="text-xs-right"><strong>{{sumNumber}}</strong></td>
                            <td class="text-xs-right"><strong>{{sumTotal.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}</strong></td>
                        </template>
                    </v-data-table>
                </v-card-text>
            </v-card>
        </v-container>
    </v-app>
</template>
<script>
import mainMenu from '@/components/mainMenu.vue'
import {db} from '@/firebase'
export default {
    components:{
        mainMenu
    },
    data(){
        return{
            // month: new Date().toISOString().substr(5,2) * 1,
            itemYear: [],
            itemMonth: [
                { id: '01', name: 'January' },
                { id: '02', name: 'February' },
                { id: '03', name: 'March' },
                { id: '04', name: 'April' },
                { id: '05', name: 'May' },
                { id: '06', name: 'June' },
                { id: '07', name: 'July' },
                { id: '08', name: 'August' },
                { id: '09', name: 'September' },
                { id: '10', name: 'October' },
                { id: '11', name: 'November' },
                { id: '12', name: 'December' },
            ],
            month: '',
            year: new Date().toISOString().substr(0,4),

            headerProd:[
                { text: 'Product code', align: 'left', value: 'code' },
                { text: 'Product name', align: 'left', value: 'name' },
                { text: 'Number', align: 'right', value: 'num' },
                { text: 'Amt', align: 'right', value: 'amt' }
            ],
            detail:[],
            prodList: [],
        }
    },
    methods:{
        changeMonth(){
            this.prodList = []
            this.month = ''
        },

        // Search report from month
        searchMonth(){
            let app = this
            let curMont = this.month*1 + 1
            db.collection("invoice").where("status", "==", "Open")
            .where("invDate", ">", this.year + "-" + this.month).where("invDate", "<", this.year + "-" + (curMont<10? '0':'') + curMont).get()
            .then(query=>{
                let arrProd = []
                app.prodList = []
                query.forEach(doc=>{
                    arrProd.push(doc.data().detail)
                })
                if(arrProd.length == 0){
                    console.log("Data does not exist in the system.")
                }
                else{
                    let newArr = []
                    arrProd.forEach(rec=>{
                        rec.forEach(item=>{
                            newArr.push(item)
                        })
                    })
                    newArr.sort((a, b) => a.Code.localeCompare(b.Code))

                    let arr = null
                    let arrName = null
                    let num = 0
                    let amt = 0
                    let count = 0
                    for (let i = 0; i < newArr.length; i++) {
                        if(newArr[i].Code != arr){
                            if(count > 0){
                                app.prodList.push({ code: arr, name: arrName, num: num, amt: amt })
                            }
                            arr = newArr[i].Code
                            arrName = newArr[i].NameMM
                            num = 0
                            amt = 0
                            num += newArr[i].num
                            amt += newArr[i].amt
                            count = 1
                        }
                        else{
                            num += newArr[i].num
                            amt += newArr[i].amt
                            count++
                        }
                    }
                    if(count > 0){
                        app.prodList.push({ code: arr, name: arrName, num: num, amt: amt })
                    }
                }
            })
        },

        // Show month report
        getProd(){
            let app = this
            let curYear = this.year*1 + 1
            let curMont = this.month*1 + 1
            db.collection("invoice").where("status", "==", "Open")
            .where("invDate", ">", this.year + "-" + this.month).where("invDate", "<", curYear.toString() + "-" + curMont.toString()).get()
            .then(query=>{
                let arrProd = []
                app.prodList = []
                query.forEach(doc=>{
                    arrProd.push(doc.data().detail)
                })
                let newArr = []
                arrProd.forEach(rec=>{
                    rec.forEach(item=>{
                        newArr.push(item)
                    })
                })
                newArr.sort((a, b) => a.Code.localeCompare(b.Code))
                // console.log(newArr)
                let arr = null
                let arrName = null
                let num = 0
                let amt = 0
                let count = 0
                for (let i = 0; i < newArr.length; i++) {
                    if(newArr[i].Code != arr){
                        if(count > 0){
                            app.prodList.push({ code: arr, name: arrName, num: num, amt: amt })
                        }
                        arr = newArr[i].Code
                        arrName = newArr[i].NameMM
                        num = 0
                        amt = 0
                        num += newArr[i].num
                        amt += newArr[i].amt
                        count = 1
                    }
                    else{
                        num += newArr[i].num
                        amt += newArr[i].amt
                        count++
                    }
                }
                if(count > 0){
                   app.prodList.push({ code: arr,  name: arrName, num: num, amt: amt })
                }
                // console.log(app.prodList)
            })
        }
    },
    computed:{
        sumNumber(){
            return this.prodList.reduce((total,item)=> total+(item.num),0)
        },
        sumTotal(){
            return this.prodList.reduce((total,item)=> total+(item.amt),0)
        }
    },
    mounted(){
        db.collection("code").doc("runYear").get()
        .then(doc=>{
            let data = doc.data().year
            data.forEach(rec=>{
                this.itemYear.push(rec)
            })
            let m = new Date().toISOString().substr(5,2)
            this.itemMonth.forEach(rec=>{
                if(rec.id == m){
                    this.month = m
                }
            })
            this.getProd()
        })
        // let nextYear = new Date().toISOString().substr(0,4)
        // db.collection("code").doc("runYear").update({
        //     year: fieldValue.arrayUnion(nextYear)
        // })
    }
}
</script>
